import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import { Link } from 'react-router-dom';
import Tilty from 'react-tilty';

const BannerOne = () => {
    const PUB = process.env.PUBLIC_URL || '';

    const frameStyle = {
        width: '100%',
        height: '200px',
        overflow: 'hidden',
        borderRadius: '12px',
        position: 'relative',
        margin: 0,
        display: 'block',
    };

    const imgStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
        display: 'block',
        margin: 0,
        padding: 0,
    };

    // Uniform button style for all four buttons - responsive sizing
    const buttonStyle = {
        padding: '12px 16px',
        fontSize: '15px',
        fontWeight: '600',
        borderRadius: '8px',
        border: '2px solid var(--color-primary)',
        backgroundColor: 'var(--color-primary)',
        color: '#ffffff',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        flex: '1 1 auto',
        minWidth: '140px',
        maxWidth: '200px',
        whiteSpace: 'nowrap',
        boxShadow: '0 4px 15px rgba(0, 123, 255, 0.2)'
    };

    const buttonOutlineStyle = {
        ...buttonStyle,
        backgroundColor: 'transparent',
        color: 'var(--color-primary)',
        boxShadow: '0 4px 15px rgba(0, 123, 255, 0.1)'
    };

    return (
        <>
        <style>{`
            @media (min-width: 992px) {
                .button-container > * {
                    flex: 0 1 calc(25% - 6px) !important;
                }
            }
            @media (min-width: 576px) and (max-width: 991px) {
                .button-container > * {
                    flex: 0 1 calc(50% - 8px) !important;
                }
            }
            @media (max-width: 575px) {
                .button-container > * {
                    flex: 0 1 100% !important;
                    max-width: 100% !important;
                }
            }
        `}</style>
        <section className="banner banner-style-1 position-relative" style={{ paddingTop: '120px' }}>
            {/* Centered Buttons Section */}
            <div className="container mb-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-7 col-xl-6">
                        <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={80}>
                            <div className="d-flex gap-2 justify-content-center button-container" style={{ flexWrap: 'wrap' }}>
                                <button
                                    style={buttonStyle}
                                    onClick={() => {
                                        const servicesSection = document.querySelector('.section.section-padding-2.bg-color-dark');
                                        if (servicesSection) {
                                            servicesSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(0, 123, 255, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(0, 123, 255, 0.2)';
                                    }}
                                    onMouseDown={(e) => {
                                        e.target.style.transform = 'translateY(1px)';
                                    }}
                                    onMouseUp={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                    }}
                                >
                                    What We Can Do
                                </button>
                                <button
                                    style={buttonOutlineStyle}
                                    onClick={() => {
                                        const aboutSection = document.querySelector('.section.section-padding-equal.bg-color-light');
                                        if (aboutSection) {
                                            aboutSection.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = 'var(--color-primary)';
                                        e.target.style.color = '#ffffff';
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(0, 123, 255, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = 'var(--color-primary)';
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(0, 123, 255, 0.1)';
                                    }}
                                    onMouseDown={(e) => {
                                        e.target.style.transform = 'translateY(1px)';
                                    }}
                                    onMouseUp={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                    }}
                                >
                                    Contact Us
                                </button>
                                <Link
                                    to="/Employment"
                                    style={buttonOutlineStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = 'var(--color-primary)';
                                        e.target.style.color = '#ffffff';
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(0, 123, 255, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = 'var(--color-primary)';
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(0, 123, 255, 0.1)';
                                    }}
                                    onMouseDown={(e) => {
                                        e.target.style.transform = 'translateY(1px)';
                                    }}
                                    onMouseUp={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                    }}
                                >
                                    Employment
                                </Link>
                                <Link
                                    to="/About"
                                    style={buttonOutlineStyle}
                                    onMouseEnter={(e) => {
                                        e.target.style.backgroundColor = 'var(--color-primary)';
                                        e.target.style.color = '#ffffff';
                                        e.target.style.transform = 'translateY(-3px)';
                                        e.target.style.boxShadow = '0 8px 25px rgba(0, 123, 255, 0.4)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.backgroundColor = 'transparent';
                                        e.target.style.color = 'var(--color-primary)';
                                        e.target.style.transform = 'translateY(0)';
                                        e.target.style.boxShadow = '0 4px 15px rgba(0, 123, 255, 0.1)';
                                    }}
                                    onMouseDown={(e) => {
                                        e.target.style.transform = 'translateY(1px)';
                                    }}
                                    onMouseUp={(e) => {
                                        e.target.style.transform = 'translateY(-3px)';
                                    }}
                                >
                                    About
                                </Link>
                            </div>
                        </AnimationOnScroll>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row align-items-center">
                    {/* Left: text content */}
                    <div className="col-lg-6">
                        <div className="banner-content">
                            <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={80}>
                                <h1 className="display-4 fw-bold mb-3">
                                    Full stack SaaS, Enterprise &amp; Mobile apps and everything ai.
                                </h1>
                                <p className="lead text-muted mb-4">
                                    We provide full-stack Software as a Service solutions, mobile development, AI integration, and
                                    cloud platforms for enterprise.
                                </p>
                            </AnimationOnScroll>
                        </div>
                    </div>

                    {/* Right: hero images */}
                    <div className="col-lg-6">
                        <div className="banner-thumbnail" style={{
                            display: 'grid', 
                            gridTemplateColumns: '1fr 1fr', 
                            gridTemplateRows: '1fr 1fr',
                            gap: '4px',
                            alignItems: 'stretch'
                        }}>
                            <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={100}>
                                <Tilty glare maxGlare={0.3} scale={1.05} max={15}>
                                    <img
                                        src={`${PUB}/images/banner/Full-Stack SaaS & Mobile Solutions.png`}
                                        alt="Full-Stack SaaS & Mobile Solutions"
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            objectFit: 'contain',
                                            objectPosition: 'center',
                                            borderRadius: '12px',
                                            display: 'block',
                                            margin: 0,
                                            padding: 0,
                                            backgroundColor: '#f8f9fa'
                                        }}
                                        loading="lazy"
                                    />
                                </Tilty>
                            </AnimationOnScroll>
                            
                            <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={140}>
                                <Tilty glare maxGlare={0.3} scale={1.05} max={15}>
                                    <img
                                        src={`${PUB}/images/banner/ChatGPT Image Sep 4, 2025, 07_41_42 AM.png`}
                                        alt="ChatGPT AI Interface"
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            objectFit: 'contain',
                                            objectPosition: 'center',
                                            borderRadius: '12px',
                                            display: 'block',
                                            margin: 0,
                                            padding: 0,
                                            backgroundColor: '#f8f9fa'
                                        }}
                                        loading="lazy"
                                    />
                                </Tilty>
                            </AnimationOnScroll>

                            <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={180}>
                                <Tilty glare maxGlare={0.3} scale={1.05} max={15}>
                                    <img
                                        src={`${PUB}/images/banner/newpic1.jpg`}
                                        alt="Coding workspace"
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            objectFit: 'cover',
                                            borderRadius: '12px',
                                            display: 'block',
                                            margin: 0,
                                            padding: 0
                                        }}
                                        loading="lazy"
                                    />
                                </Tilty>
                            </AnimationOnScroll>

                            <AnimationOnScroll animateIn="fadeInUp" animateOnce delay={220}>
                                <Tilty glare maxGlare={0.3} scale={1.05} max={15}>
                                    <img
                                        src={`${PUB}/images/banner/newpic2.jpg`}
                                        alt="Team collaboration"
                                        style={{
                                            width: '100%',
                                            height: '120px',
                                            objectFit: 'cover',
                                            borderRadius: '12px',
                                            display: 'block',
                                            margin: 0,
                                            padding: 0
                                        }}
                                        loading="lazy"
                                    />
                                </Tilty>
                            </AnimationOnScroll>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};

export default BannerOne;
